@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .root {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid var(--border-soft);
    @include border-radius-r2;
  }

  .accentSuccess {
    background:
      linear-gradient(
        90deg,
        var(--background-soft) 0%,
        color-mix(in srgb, var(--surface-success) 50%, transparent) 100%
      ),
      var(--background-soft);
  }

  .accentError {
    background:
      linear-gradient(
        90deg,
        var(--background-soft) 0%,
        color-mix(in srgb, var(--surface-critical) 50%, transparent) 100%
      ),
      var(--background-soft);
  }

  .accentWarning {
    background:
      linear-gradient(
        90deg,
        var(--background-soft) 0%,
        color-mix(in srgb, var(--surface-warning) 50%, transparent) 100%
      ),
      var(--background-soft);
  }

  .bodySection {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .metaRow {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .eyebrow {
    @include typography-v2-title-sm;
    color: var(--text-soft);
    white-space: nowrap;
  }

  .body {
    @include typography-v2-body-base;
    color: var(--text-default);
  }

  .footnote {
    @include typography-v2-body-xs;
    color: var(--text-soft);
  }
}
